/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable max-len */
import React from 'react';
import { twMerge } from 'tailwind-merge';

interface ClockProps {
  className?: string;
  width?: number;
  height?: number;
}

const ClockIcon = function ClockIcon({
  className,
  width,
  height,
}: ClockProps): JSX.Element {
  //   <circle cx="12" cy="12" r="11.5" fill="#798897" stroke="#798897" />
  //   <path d="M12 4.6665V11.7498C12
  //  11.8879 12.1119 11.9998 12.25 11.9998H16.6667" stroke="#F7F7F7" stroke-linecap="round" />

  console.log('className', className);

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      className="mr-3"
      fill="none"
      viewBox="0 0 24 24"
    >
      <circle xmlns="http://www.w3.org/2000/svg" cx="12" cy="12" r="11.5" className={className} />
      {/* <circle cx="12" cy="12" r="8.5" stroke="#798897" className={twMerge(className, 'fill-[#798897]')} /> */}
      {/* <circle cx="12" cy="12" r="11.5" fill="#798897" stroke="#798897" className="mr-3" /> */}
      <path d="M12 4.6665V11.7498C12 11.8879 12.1119 11.9998 12.25 11.9998H16.6667" stroke="#F7F7F7" strokeLinecap="round" />
    </svg>

  );
};

ClockIcon.defaultProps = {
  className: '',
  width: 24,
  height: 24,
};

export default ClockIcon;

/**
 *
 * Secondary - #798897
 * primary- #F97171

EXPECTED

While Selected
  < svg xmlns = "http://www.w3.org/2000/svg" width = "27" height = "27" viewBox = "0 0 27 27" fill = "none" >
<circle cx="13.5" cy="13.5" r="13.5" fill="#F97171"/>
<path d="M13.5 5.25V13.25C13.5 13.3881 13.6119 13.5 13.75 13.5H18.75" stroke="#F7F7F7" stroke-linecap="round"/>
</ >

while not selected
<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
<circle cx="12" cy="12" r="11.5" fill="#798897" stroke="#798897"/>
<path d="M12 4.6665V11.7498C12 11.8879 12.1119 11.9998 12.25 11.9998H16.6667" stroke="#F7F7F7" stroke-linecap="round"/>
</svg>

ACTUAL

While selcted
<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24" class="mr-3">
<circle xmlns="http://www.w3.org/2000/svg" cy="12" r="11.5" cx="12" class="stroke-primary mr-3 fill-secondary" fill="#798897"></circle>
<path d="M12 4.6665V11.7498C12 11.8879 12.1119 11.9998 12.25 11.9998H16.6667" stroke="#F7F7F7" stroke-linecap="round">
</path>
</svg>

While Not selected
<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24" class="mr-3">
<circle xmlns="http://www.w3.org/2000/svg" cy="12" r="11.5" cx="12" class="stroke-secondary mr-3 fill-secondary" fill="#798897">
</circle>
<path d="M12 4.6665V11.7498C12 11.8879 12.1119 11.9998 12.25 11.9998H16.6667" stroke="#F7F7F7" stroke-linecap="round">
</path>
</svg>

*/
